/**
 * フリーメール（個人向け無料メール）ドメイン判定
 *
 * B2B フォーム等で個人メールアドレスを弾くための共通ユーティリティ。
 * 新しいドメインを弾きたい場合は下記の配列に追記するだけでよい。
 */

// 一般的な無料 Web メール
const FREE_WEBMAIL_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'yahoo.co.jp',
  'yahoo.com',
  'ymail.com',
  'outlook.com',
  'outlook.jp',
  'hotmail.com',
  'hotmail.co.jp',
  'live.jp',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
  'gmx.com',
  'mail.com',
  'zoho.com',
  'qq.com',
  '163.com',
  '126.com',
  'sina.com',
  'naver.com',
];

// 日本の携帯キャリアメール（個人利用のため B2B では弾く）
const CARRIER_MAIL_DOMAINS = [
  'docomo.ne.jp',
  'ezweb.ne.jp',
  'au.com',
  'softbank.ne.jp',
  'i.softbank.jp',
  'ymobile.ne.jp',
  'ec.docomo.ne.jp',
];

const FREE_EMAIL_DOMAINS = new Set([...FREE_WEBMAIL_DOMAINS, ...CARRIER_MAIL_DOMAINS].map((d) => d.toLowerCase()));

/**
 * メールアドレスがフリーメール（個人メール）かどうかを判定する。
 * 形式が不正な場合は false を返し、形式チェックは呼び出し側の責務とする。
 */
export const isFreeEmailDomain = (email: string): boolean => {
  const domain = email.trim().toLowerCase().split('@')[1];
  if (!domain) return false;
  return FREE_EMAIL_DOMAINS.has(domain);
};
